import { render, staticRenderFns } from "./ClientesCanal.vue?vue&type=template&id=2eb02bd9&scoped=true&"
import script from "./ClientesCanal.vue?vue&type=script&lang=ts&"
export * from "./ClientesCanal.vue?vue&type=script&lang=ts&"
import style0 from "./ClientesCanal.vue?vue&type=style&index=0&id=2eb02bd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb02bd9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2eb02bd9', component.options)
    } else {
      api.reload('2eb02bd9', component.options)
    }
    module.hot.accept("./ClientesCanal.vue?vue&type=template&id=2eb02bd9&scoped=true&", function () {
      api.rerender('2eb02bd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ClientesCanal/ClientesCanal.vue"
export default component.exports